module.exports={
	"Scope": "ObservationApprovalState-List",
	"CoreEntity": "ObservationApprovalState",
	"TitleTemplate": "Observation Approval States",
	"Descriptors":
	{
		"Name":
		{
			"Name": "State Name",
			"Hash": "ObsStateListName",
			"PictDashboard": {}
		},
		"Hash":
		{
			"Name": "Hash",
			"Hash": "ObsStateListHash",
			"PictDashboard": {}
		}
	}
}
